var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isComponentSettings
    ? _c(
        "div",
        { staticClass: "d-flex align-items-center" },
        [
          _c(
            _setup.Button,
            {
              attrs: {
                "default-class": _setup.btnClass,
                disabled: _setup.inProgress,
              },
              on: { click: _setup.toggleCategories },
            },
            [_vm._v("\n        " + _vm._s(_setup.btnLabel) + "\n    ")]
          ),
          _vm._v(" "),
          _setup.inProgress
            ? _c("span", {
                staticClass: "ms-2 ajax-spinner-icon ajax-spinner-icon-sm",
              })
            : _vm._e(),
        ],
        1
      )
    : _c(_setup.FormControlTypeRelationshipOneToMany, {
        attrs: {
          "current-data": _vm.currentData,
          field: _vm.field,
          "form-id": _vm.formId,
        },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }